"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnownB2BDestination = void 0;
exports.KnownB2BDestination = {
    FBA: "FBA",
};
//# sourceMappingURL=known-b2-bdestination.js.map